import React from 'react';
import PropTypes from 'prop-types';

const NO_FILL = { fill: 'none' };

const Svg = ({ children, className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);

Svg.propTypes = { children: PropTypes.node.isRequired, className: PropTypes.string };
Svg.defaultProps = { className: '' };

export const ArrowRight = ({ className }) => (
  <Svg className={className}><path d="M5 12h14M13 6l6 6-6 6" style={NO_FILL} /></Svg>
);

export const Chevron = ({ className }) => (
  <Svg className={className}><path d="m9 6 6 6-6 6" style={NO_FILL} /></Svg>
);

export const ChevronDown = ({ className }) => (
  <Svg className={className}><path d="m6 9 6 6 6-6" style={NO_FILL} /></Svg>
);

export const LayersIcon = ({ className }) => (
  <Svg className={className}>
    <path d="m12 3 9 5-9 5-9-5 9-5Z" style={NO_FILL} />
    <path d="m3 13 9 5 9-5" style={NO_FILL} />
  </Svg>
);

export const WalletIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M4 7a2 2 0 0 1 2-2h11v4" style={NO_FILL} />
    <rect x="4" y="7" width="16" height="12" rx="2.5" style={NO_FILL} />
    <path d="M16 13h2" style={NO_FILL} />
  </Svg>
);

export const CardIcon = ({ className }) => (
  <Svg className={className}>
    <rect x="3" y="5" width="18" height="14" rx="2.5" style={NO_FILL} />
    <path d="M3 10h18M7 15h3" style={NO_FILL} />
  </Svg>
);

export const CapIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M2 9.5 12 4.5l10 5-10 5z" style={NO_FILL} />
    <path d="M6 11.5v4.8c3.3 2.3 8.7 2.3 12 0v-4.8" style={NO_FILL} />
    <path d="M22 9.5v5" style={NO_FILL} />
  </Svg>
);

export const InfoIcon = ({ className }) => (
  <Svg className={className}>
    <circle cx="12" cy="12" r="9" style={NO_FILL} />
    <path d="M12 11v5M12 8h.01" style={NO_FILL} />
  </Svg>
);

export const DownloadIcon = ({ className }) => (
  <Svg className={className}><path d="M12 4v11m0 0-4.5-4.5M12 15l4.5-4.5M5 20h14" style={NO_FILL} /></Svg>
);

export const CopyIcon = ({ className }) => (
  <Svg className={className}>
    <rect x="9" y="9" width="11" height="11" rx="2.5" style={NO_FILL} />
    <path d="M5 15V6a2 2 0 0 1 2-2h9" style={NO_FILL} />
  </Svg>
);

export const BooksIcon = ({ className, count }) => (
  <svg className={className} viewBox="0 0 64 48" aria-hidden="true">
    {Array.from({ length: count }).map((_, idx) => (
      <g key={idx} transform={`translate(${4 + idx}, ${34 - idx * 8})`}>
        <rect x="0" y="0" width="54" height="9" rx="2.5" fill="#c9b4ec" />
        <rect x="0" y="0" width="54" height="4" rx="2" fill="#a98ade" />
        <rect x="44" y="1.5" width="8" height="6" rx="1.5" fill="#ffffff" opacity=".7" />
      </g>
    ))}
  </svg>
);

ArrowRight.propTypes = { className: PropTypes.string };
ArrowRight.defaultProps = { className: '' };

Chevron.propTypes = { className: PropTypes.string };
Chevron.defaultProps = { className: '' };

ChevronDown.propTypes = { className: PropTypes.string };
ChevronDown.defaultProps = { className: '' };

LayersIcon.propTypes = { className: PropTypes.string };
LayersIcon.defaultProps = { className: '' };

WalletIcon.propTypes = { className: PropTypes.string };
WalletIcon.defaultProps = { className: '' };

CardIcon.propTypes = { className: PropTypes.string };
CardIcon.defaultProps = { className: '' };

CapIcon.propTypes = { className: PropTypes.string };
CapIcon.defaultProps = { className: '' };

InfoIcon.propTypes = { className: PropTypes.string };
InfoIcon.defaultProps = { className: '' };

DownloadIcon.propTypes = { className: PropTypes.string };
DownloadIcon.defaultProps = { className: '' };

CopyIcon.propTypes = { className: PropTypes.string };
CopyIcon.defaultProps = { className: '' };

BooksIcon.propTypes = { className: PropTypes.string, count: PropTypes.number };
BooksIcon.defaultProps = { className: '', count: 2 };
